{
  "label": "groupe d'utilisateur",
  "button": {
    "delete": "Supprimer le groupe",
    "create": "Nouveau groupe"
  },
  "confirmDelete": {
    "title": "Suppression d'un groupe",
    "description": "Le groupe sélectionné \"{userGroupName}\" sera supprimé"
  },
  "cannotDelete": {
    "title": "Suppression d'un groupe impossible",
    "description": "Le groupe sélectionné \"{userGroupName}\" est associé à {usersCount} utilisateur(s)"
  },
  "empty": "Aucun groupe n'a été trouvé",
  "search": "Recherche par nom",
  "create": {
    "title": "Nouveau groupe",
    "confirm": {
      "title": "Création d'un groupe"
    }
  },
  "update": {
    "title": "Modifier un groupe",
    "confirm": {
      "title": "Mise à jour du groupe"
    }
  },
  "confirm": {
    "message": "Confirmez-vous l’annulation de l’opération ? Toutes les données non enregistrées seront perdues."
  },
  "information": "Informations du groupe",
  "name": "Nom du groupe",
  "sector": {
    "title": "Secteurs"
  },
  "sectors": {
    "label": "Secteurs associés au groupe"
  },
  "addUsers": {
    "title": "Ajouter des utilisateurs"
  }
}
